// openEHR BASE model — shared internals (not part of the public barrel)
// Generated by tasks/split_model_by_bmm_packages.ts from tasks/bmm_package_map.json.
// Package boundaries follow the BMM package structure; edit the class bodies here,
// but re-run the splitter rather than hand-moving declarations between packages.

// Hand-written implementation based on BMM schema: base v1.3.0
// BMM Version: 2.4
// Schema Revision: 1.3.0.2
// Description: openEHR base types.
// Source: https://raw.githubusercontent.com/openEHR/specifications-BASE/master/computable/BMM/openehr_base_1.3.0.bmm.json
// Last synced with BMM: 2026-09-16
//
// ✅ ENHANCED IMPLEMENTATION
// This file contains fully implemented methods and additional functionality beyond the BMM specification.
// It is safe to edit this file - your changes will not be overwritten by the generator.
//
// The generator outputs to /generated directory. To update this file for a new BMM version:
// 1. Run generator to update /generated/openehr_base.ts
// 2. Compare changes using: deno run --allow-read tasks/compare_bmm_versions.ts
// 3. Manually merge relevant changes into this file
//
// For more information about openEHR specifications, visit: https://specifications.openehr.org/

// ISO 8601 arithmetic uses Deno's built-in Temporal global (2.7+, no flag).
// See: https://docs.deno.com/api/web/temporal

import type { Any } from "./foundation_types/foundation_types.ts";
import type { Boolean } from "./foundation_types/primitive_types.ts";

// Unknown types - defined as 'any' for now
export type T = any;

// Type alias for container predicates. Official BASE BMM (SPECBASE-48) types
// these as FUNCTION<TUPLE1<T>, Boolean>; a TypeScript `(v: T) => Boolean` is
// the equivalent callable form.
export type Operation<T = any> = (v: T) => Boolean;

// Type registry for dynamic type instantiation via instance_of()
// Maps uppercase type names to their constructors
export const TYPE_REGISTRY: Map<string, new () => Any> = new Map();

/**
 * Register a type for dynamic instantiation via instance_of().
 * Types must be registered before they can be created dynamically.
 * @param name - The type name (case-insensitive)
 * @param constructor - The constructor function for the type
 */
export function registerType(name: string, constructor: new () => Any): void {
  TYPE_REGISTRY.set(name.toUpperCase(), constructor);
}

/**
 * Check if a type is registered for dynamic instantiation.
 * @param name - The type name (case-insensitive)
 * @returns True if the type is registered
 */
export function isTypeRegistered(name: string): boolean {
  return TYPE_REGISTRY.has(name.toUpperCase());
}

/**
 * Get all registered type names.
 * @returns Array of registered type names (uppercase)
 */
export function getRegisteredTypes(): string[] {
  return [...TYPE_REGISTRY.keys()];
}

// ============================================================================
// Type Registry Note
// ============================================================================
// Type registrations are now lazy - they use static initialization blocks
// within each class definition (e.g., `static { TYPE_REGISTRY.set(...) }`).
// This approach provides several benefits:
// 1. Tree-shaking: Unused types won't add their registration code to bundles
// 2. Efficient runtime: Registration only happens when the class is actually loaded
// 3. No module-level side effects: Better for ES module optimization
//
// See the Optimization Strategy section in tasks/design-alternatives-remaining-base-methods.md
// for more details on this approach.
